import LogisticStep1 from "../LogisticBidSubmission/LogisticStep1";

const Step1 = (props) => {
  return <LogisticStep1 {...props} />;
};

export default Step1;
